import React from 'react';
import { ControllerStateAndHelpers } from 'downshift';
import { useHawkSearch } from 'components/StoreProvider';
import SearchBoxBase from 'components/ui/SearchBox/SearchBoxBase';
import { Product } from 'models/Autocomplete';

/**
 * This component is the search input box (with autosuggest) that should be utilized on search pages. For a simple
 * search input box that is meant to be used on non-search pages (or globally), see `GlobalSearchBox`.
 */
function SearchBox() {
	const { store, actor } = useHawkSearch();

	function handleSubmit(keywords: string) {
		const request = {
			PageId: undefined,
			PageNo: undefined,
			CustomUrl: undefined,
			Keyword: keywords,
			FacetSelections: undefined,
		};

		actor.setSearch(request);
	}

	// On Select view all matches from suggestion list
	function handleViewAllMatches(downshift: ControllerStateAndHelpers<Product>) {
		const { inputValue, closeMenu } = downshift;

		const request = {
			PageId: undefined,
			PageNo: undefined,
			CustomUrl: undefined,
			Keyword: inputValue ?? '',
		};

		actor.setSearch(request);
		closeMenu();
	}

	return (
		<div className="hawk__searchBox">
			<SearchBoxBase
				onViewMatches={handleViewAllMatches}
				initialValue={store && store.pendingSearch ? store.pendingSearch.Keyword : ''}
				onSubmit={handleSubmit}
			/>
		</div>
	);
}

export default SearchBox;
